var map = {
	"./grch37": [
		7842,
		842
	],
	"./grch37.js": [
		7842,
		842
	],
	"./grch38": [
		2893,
		893
	],
	"./grch38.js": [
		2893,
		893
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7505;
module.exports = webpackAsyncContext;